import BinaryCoverages from "./BinaryCoverages";
import CatCoverages from "./CatCoverages";
import Layers from "./Layers";
import NonCatCoverages from "./NonCatCoverages";
import Perils from "./Perils";
import PrimaryTower from "./PrimaryTower";
import Tower from "./Tower";
import FeatureFlagged from "components/common/FeatureFlagged";
import Toggle from "components/common/Toggle";
import Visible from "components/common/Visible";
import ActiveLayerEditor from "components/layers/ActiveLayerEditor";
import ActiveLayerSelector from "components/layers/ActiveLayerSelector";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import * as pricingActions from "store/actions/pricing/pricingActions";

const PRIMARY_TOWER_TAG = "input.coverage.primaryTower";

const Layers20240907 = () => (
  <>
    <ActiveLayerSelector
      includedColumnKeys={[
        "delete",
        "status",
        "copyId",
        "shareOfLimit",
        "limit",
        "attachment",
        "grossPremium",
        "grossPPM",
        "shareOfNetPremium",
        "tac",
      ]}
    />
    <ActiveLayerEditor />
  </>
);

const Sublimits = () => {
  const dispatch = useDispatch();

  // Stable, because it is handed to the memoised tower rows via the shared
  // tower component and a fresh reference on every render would defeat them.
  const handleCopyLayer = useCallback(
    (layer) => {
      dispatch(
        pricingActions.addLayer({
          limit: layer.limit,
          attachment: layer.attachment,
          brokerTargetGrossPremium: layer.grossPremium,
          comment: layer.comments,
        })
      );
    },
    [dispatch]
  );

  return (
    <>
      <Visible byTag={"input.coverage.perils"} defaultVisible>
        <Perils />
      </Visible>
      <Visible byTag={"input.coverage.cat"} defaultVisible>
        <CatCoverages />
      </Visible>
      <Visible byTag={"input.coverage.noncat"} defaultVisible>
        <NonCatCoverages />
      </Visible>
      <Visible byTag={"input.coverage.binary"} defaultVisible={false}>
        <BinaryCoverages />
      </Visible>
      <FeatureFlagged
        flag={"ui/revertCoverageLayer"}
        on={Layers20240907}
        off={Layers}
      />
      <Toggle
        byTag={PRIMARY_TOWER_TAG}
        defaultToggle={false}
        trueChild={<PrimaryTower onCopyLayer={handleCopyLayer} />}
        falseChild={<Tower onCopyLayer={handleCopyLayer} />}
      />
    </>
  );
};

export default Sublimits;
